import { Native } from './';

/**
 * Should we  claim native install reward
 */
export function hasAppInstallReward(state: Native.State) {
  return state.native.appInstallRewardStatus === 'received';
}
